import module from "./header-component";
export default module;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/directives/header-component/index.js